import { ProductScreenshot } from 'components/ProductScreenshot';
import CreateNewFeatureFlagLight from "../../../../contents/images/features/feature-flags/create-new-feature-flag-light-mode.png";
import CreateNewFeatureFlagDark from "../../../../contents/images/features/feature-flags/create-new-feature-flag-dark-mode.png";
import SiteAppDark from "../../../../contents/images/features/feature-flags/site-app-light-mode.png";
import SiteAppLight from "../../../../contents/images/features/feature-flags/site-app-dark-mode.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  CreateNewFeatureFlagLight,
  CreateNewFeatureFlagDark,
  SiteAppDark,
  SiteAppLight,
  React
};